import { Tooltip, Typography } from 'antd'
import { NotificationEventItem } from '@cims-online/shared'
import { useCIMSNotificationsContext } from '../CIMSNotificationsContext'
import { WithEvent } from './CIMSNotificationsPanelContext'

function PanelHeader<Event extends NotificationEventItem>({
  event: { name, description, id },
}: Pick<WithEvent<Event>, 'event'>) {
  const { __debug } = useCIMSNotificationsContext()
  return (
    <Typography.Text>
      <Tooltip title={__debug ? id : undefined}>
        {name} : {description}
      </Tooltip>
    </Typography.Text>
  )
}

export default PanelHeader
